import { ElementRef, Injectable } from '@angular/core';
import * as OT from '@opentok/client';
import { TokboxCredentials } from 'src/app/types/TokboxCredentials';
import { createVideoBoxElement } from '../utils/VideoBox';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OpentokService {
  session: OT.Session;
  publisher: OT.Publisher;
  suscriber: OT.Subscriber;
  token: string;

  constructor() {}

  get OT() {
    return OT;
  }

  initSession({ apiKey, sessionId, token }: TokboxCredentials): OT.Session {
    this.token = token;
    this.session = this.OT.initSession(apiKey, sessionId);
    return this.session;
  }

  async suscribe(stream: OT.Stream, elementRef: ElementRef<HTMLDivElement>) {
    this.suscriber = await this.session.subscribe(
      stream,
      elementRef.nativeElement,
      {
        fitMode: 'cover',
        width: '100%',
        height: '100%',
        insertMode: 'append',
        showControls: false,
      },
      (err) => {
        if (err) {
          console.log(err);
        }
      }
    );

    if (!this.suscriber.element) return 
    createVideoBoxElement(this.suscriber.element.id, false);
  }

  connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.session.connect(this.token, (err) => {
        if (err) reject(err);
        else resolve();
      });
    });
  }

  publish(elementRef: ElementRef<HTMLDivElement>, isMedic: number): Promise<void> {
    return new Promise((resolve, reject) => {
      let publishAudio = false 

      if (environment.production) publishAudio = isMedic ? false : true

      this.publisher = OT.initPublisher(
        elementRef.nativeElement,
        {
          width: '100%',
          height: '100%',
          insertMode: 'append',
          fitMode: 'cover',
          publishAudio,
          publishVideo: true,
          showControls: false,
        },
        (err) => {
          if (err) reject(err);
          else {
            createVideoBoxElement(this.publisher.element.id, true);

            this.session.publish(this.publisher, (err) => {
              if (err) reject(err);
              else resolve();
            });
          }
        }
      );
    })
  }
}
